module.exports = __webpack_public_path__ + "static/media/background-2-1690w.a514c51e.webp";